module.exports = __webpack_public_path__ + "media/images/gallery/constellations/auriga/aur_ir-a3b211866178e08909735d62bac8e134.jpg";